import type { ReactNode } from 'react';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconAlert } from '#src/atoms/icons/system/iconAlert.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { Level } from '#src/contexts/snackNotification/index.ts';

export const Message = ({
  level,
  notification,
}: {
  level: Level;
  notification: ReactNode;
}) => {
  if (!notification) {
    return null;
  }
  return (
    <Horizontal>
      {(level === Level.ERROR || level === Level.WARN) && (
        <FontAwesomeIcon
          icon={iconAlert}
          size="lg"
          color={
            level === Level.ERROR ? 'var(--c-red-500)' : 'var(--c-yellow-500)'
          }
        />
      )}
      <span>{notification}</span>
    </Horizontal>
  );
};
